/**
 * P3 SP1 — the session's default trail id, for the lens snapshot's
 * legacy-null rule. Source: conversation state metadata when the loader
 * kept it; fallback: the first loaded message's stamped trail_id (every
 * operator message carries metadata.trail_id since Trailmap L1).
 */
import { useConversation } from '../contexts/ConversationContext';

export function useDefaultTrailId(): string | null {
  const { state } = useConversation();
  const fromMeta = (state.metadata as any)?.default_trail_id;
  if (fromMeta) return String(fromMeta);
  for (const m of state.messages) {
    const t = (m.metadata as any)?.trail_id;
    if (t) return String(t);
  }
  return null;
}
